import React, { useEffect, useState } from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux"
import WellnessScore from '../WellnessScore'
import AssessmentIcon from '@mui/icons-material/Assessment'
import SummarizeIcon from '@mui/icons-material/Summarize'
import EditIcon from '@mui/icons-material/Edit'
import { Button, Grid, Box, Typography, Modal, Stack, Paper, Card, CardHeader, Avatar, CardContent, CardActions, IconButton, Divider } from '@mui/material'
import { surveyClear } from "../../../reducers/survey"
import { stubTrue } from 'lodash'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const PreferredCardComplete = (props) => {

    const AssessmentObject = props.AssessmentObject
    const { EditAssessmentWarning } = AssessmentObject

    const { user: currentUser } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const CanEdit = AssessmentObject.HRAModeCanEdit === '1'
    const showStart = AssessmentObject.HRAModeCanTakeAnother == '1'
    const AssessmentGuid = AssessmentObject.ResponseId_Guid
    const dispatch = useDispatch();
    const surveyStatus = useSelector(state => state.surveys.status)

    const [open, setOpen] = useState(false)
    const [guid, setGuid] = useState("")

    const currentAssessmentDate = AssessmentObject.ResponseCreated;
    const displayDate = (currentAssessmentDate ? currentAssessmentDate.split(' ')[0] : null)

    useEffect(() => {
        if (surveyStatus === 'success') {

            dispatch(surveyClear())
        }
    }, [surveyStatus])

    const handleClose = () => {
        setOpen(false)
    }

    const handlePRClick = () => {

        if (AssessmentGuid) {

            fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + AssessmentGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    navigate({ pathname: '/personalreport', search: createSearchParams({ vi: '8AC17D1E-2871-44D9-ACC0-867285149337' }).toString() })
                })
        }
    }

    const handlePSClick = () => {


        if (AssessmentGuid) {
            fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + AssessmentGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {
                    navigate({ pathname: '/physiciansummary', search: createSearchParams({ vi: '2C2870C1-1C00-4E67-98FF-04BA402C6824' }).toString() })
                }
                )
        }
    }


    const handleEditClick = (guid) => {

        setOpen(true)
        setGuid(guid)
    }

    const handleStartEdit = () => {
        if (guid) {
            fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + props.settings.SessionVariableValues["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' + AssessmentObject.AssessmentProductGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + AssessmentGuid + '/', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: {
                    }
                })
                    .then(response => {

                        navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701', assmtguid: AssessmentGuid }).toString() })
                    })
                )
        }
    }

    const handleStart = () => {
        fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + props.settings.SessionVariableValues["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' + AssessmentObject.AssessmentProductGuid + '/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        })
            .then(response => response.json())
            .then(response => {

            })
            .then(fetch('../../WsWebServicePlatform/Participant/SessionVar/Delete/' + currentUser.AuthToken + '/RESPONSE%20GUID/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(response => response.json())
                .then(response => {

                    navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701' }).toString() })
                }))
    }


    return (
        <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
            <Card p={3} >

                <CardContent width={"100%"} p={4}>
                    <Grid container direction="row" justifyContent={"center"} alignItems="center" spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}>

                                <Box sx={{ maxWidth: { xs: '150px', md: '175px' } }}>
                                    <WellnessScore CurrentOWSValue={AssessmentObject.OverallScore} />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Stack direction={"column"} gap={1} p={2}>
                                <Typography variant="h5" align="left" >{AssessmentObject.SurveyDescription}</Typography>
                                <Typography variant="body1" align="left">{AssessmentObject.CompletedContent}</Typography>


                                <Stack direction={{ xs: "column", md: "row" }} sx={{ width: "100%", justifyContent: "center", alignItems: "center" }} gap={2}>

                                    {
                                        AssessmentObject.PRGuid &&
                                        AssessmentObject.PRGuid.length > 0 && (

                                            <Button variant="text"
                                                onClick={() => handlePRClick()}
                                            >
                                                <Stack direction="row" gap={1}>
                                                    <AssessmentIcon />
                                                    <Typography variant="button" sx={{ color: "#000000" }}>{AssessmentObject.PersonalReportButton}</Typography>
                                                </Stack>
                                            </Button>
                                        )
                                    }
                                    {
                                        AssessmentObject.PSGuid &&
                                        AssessmentObject.PSGuid.length > 0 && (
                                            <Button variant="text" onClick={() => handlePSClick()} >
                                                <Stack direction="row" gap={1} >
                                                    <SummarizeIcon />
                                                    <Typography variant="button" sx={{ color: "#000000" }}>{AssessmentObject.PhysicianSummaryButton}</Typography>
                                                </Stack>
                                            </Button>
                                        )
                                    }
                                    {
                                        CanEdit && (
                                            <Button variant="text" onClick={() => handleEditClick(AssessmentGuid)} >
                                                <Stack direction="row" gap={2} >
                                                    <EditIcon />
                                                    <Typography variant="button" sx={{ color: "#000000" }}>{AssessmentObject.EditButton}</Typography>
                                                </Stack>
                                            </Button>
                                        )
                                    }
                                { showStart && (
                                        <Button variant="text" onClick={() => handleStart()} >
                                            <Stack direction="row" gap={1} >
                                                <Typography variant="button" sx={{ color: "#000000" }}>{AssessmentObject.TakeAssessmentContent}</Typography>
                                            </Stack>
                                        </Button>
                                )
                                }
                                </Stack>
                            </Stack>
                        </Grid>




                    </Grid>
                </CardContent>
            </Card>

            <Modal
                open={open}
                onClose={handleClose}>
                <Box sx={{
                    position: "absolute",
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { sm: 500, xs: 400 },
                    padding: "15px",
                    borderRadius: "12px",
                    backgroundColor: "white",
                    boxShadow: 24, '& button': { m: 1 }
                }}>
                    <Typography variant="h5">{EditAssessmentWarning.Text}</Typography>
                    <Button variant="contained" size="large" onClick={() => handleStartEdit()}>{EditAssessmentWarning.Continue}</Button>
                    <Button variant="outlined" size="large" onClick={() => handleClose()}>{EditAssessmentWarning.Exit}</Button>
                </Box>
            </Modal>
        </motion.div >
    )


}

export default PreferredCardComplete; 